import styled from "styled-components";
import theme from "constants/theme-constants";
import InteractiveLandingMap from "../tools/InteractiveLandingMap";

import { Container } from "components/ui-kit/styled-templates";

import useBodyBackground from "hooks/useBodyBackground";
import Russia2023Map from "../russia/Russia2023Map";
import RoomChatPanel from "../chat/panels/RoomChatPanel";

// import ru_map from '../../assets/images/ru_map.svg'

const COLORS = [
    "blue",
    "lightblue",
    "halfblue",
    "red",
    "grey",
    "green",
    "nice_green",
    "yellow"
];

const BACKGROUNDS = [
    "primary",
    "secondary",
    "support"
];

const TEXTS = [
    "primary",
    "secondary",
    "light"
];


const DevPage = () => {
    useBodyBackground("white");

    let colors = COLORS.map(c => theme[c]);
    let backs = BACKGROUNDS.map(c => theme.background[c]);
    let texts = TEXTS.map(c => theme.text[c]);


    return (
        <Container>
            <InnerPlaceholder>
                {/*<InteractiveLandingMap />*/}
                {/*<Russia2023Map/>*/}

                {/*<div style={{width: '400px', height: '400px', backgroundColor: 'pink'}} >*/}
                {/*    <RoomChatPanel*/}
                {/*        roomId={'sabir'}*/}
                {/*    />*/}
                {/*</div>*/}

                <h1>
                    Цвета
                </h1>

                <Row>
                    {colors.map(x => {
                        return (
                            <Box style={{ backgroundColor: x }}>

                            </Box>
                        );
                    })}
                </Row>

                <h1>
                    Фоновые цвета
                </h1>

                <Row>
                    {backs.map(x => {
                        return (
                            <Box style={{ backgroundColor: x }}>

                            </Box>
                        );
                    })}
                </Row>

                <h1>
                    Текст
                </h1>

                <div>
                    {texts.map(x => {
                        return (
                            <div style={{ color: x, marginTop: 5, marginBottom: 5 }}>
                                {"Цель Программы – создание единого пространства для культурного, профессионального и личностного развития молодежи в России. "}
                            </div>
                        );
                    })}
                </div>


            </InnerPlaceholder>
        </Container>
    );
};

const Box = styled.div`
  width: 50px;
  height: 50px;
  margin: 10px;
  border: 1px dashed grey;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

const MapImg = styled.img`
  height: 600px;
`;

const InnerPlaceholder = styled.div`
  width: 1020px;
  height: 700px;
`;

export default DevPage;
